module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "particles-js",
      "color": _vm.color,
      "particleOpacity": _vm.particleOpacity,
      "linesColor": _vm.linesColor,
      "particlesNumber": _vm.particlesNumber,
      "shapeType": _vm.shapeType,
      "particleSize": _vm.particleSize,
      "linesWidth": _vm.linesWidth,
      "lineLinked": _vm.lineLinked,
      "lineOpacity": _vm.lineOpacity,
      "linesDistance": _vm.linesDistance,
      "moveSpeed": _vm.moveSpeed,
      "hoverEffect": _vm.hoverEffect,
      "hoverMode": _vm.hoverMode,
      "clickEffect": _vm.clickEffect,
      "clickMode": _vm.clickMode
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35e3270d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-particles/src/vue-particles/vue-particles.vue
// module id = 1416
// module chunks = 0